
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class InvoiceDetail extends Vue {
  public invoice = [];
  public token = '';
  public redirect = '';
  public itemHeaders = [
    { text: 'کالا', value: 'product' },
    { text: 'تعداد', value: 'quantity' },
    { text: 'مبلغ', value: 'price' },
    { text: 'جمع کل', value: 'totalPrice' }
  ];
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'فاکتور های فروش',
      disabled: false,
      href: '/billing/invoice'
    },
    {
      text: 'فاکتور',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getInvoice(parseInt(this.$route.params.id)).then((response: any) => {
      this.invoice = response.data;
      this.$hideLoading();
    });
  }

  async close() {
    this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColor(invoiceStatus: string) {
    if (invoiceStatus === 'پرداخت شده') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
